import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#8e41c1',
        secondary: '#505050',
      },
      dark: {
        primary: '#8e41c1',
        secondary: '#505050',
      }
    },
  },
});
